import {Injectable, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {CacheService} from "../../../shared/services/cache-service";
import {environment} from "../../../../environments/environment.development";
import {MenusInterface} from "../../mnto-menus/interfaces/menus.interface";
import {RolesInterface} from "../../mnto-roles/interfaces/roles.interface";
import {
    AsignarRolesUsuario,
    CambioDocumentoReq,
    CredencialEstado, CredencialRolEstado,
    ResetCliente,
    ResetCredencial,
    ResetResponse,
    UsuarioCorreoReq,
    UsuariosInterface
} from "../interfaces/usuarios.interface";
import {Param} from "../../../shared/interfaces/param-interface";
import { PersonaInfo } from 'src/app/shared/interfaces/shared-interface';

let apiVucUrl = environment.apiVucUrl
@Injectable({
  providedIn: 'root'
})
export class UsuariosService implements OnInit{

    constructor(private http: HttpClient, private cacheService: CacheService) {
    }

    ngOnInit() {
    }

    getUsuarios(params: Param[]){
        let url = apiVucUrl + `api/v1.0/usuarios/`;
        return this.http.post<UsuariosInterface[]>(url, params, {observe: 'response'});
    }
    
    actualizarCorreo(usuarioCorreoReq: UsuarioCorreoReq){
        let url = apiVucUrl + `api/v1.0/usuarios/`;
        return this.http.put<UsuarioCorreoReq>(url, usuarioCorreoReq, {observe: 'response'});
    }

    resetCredencial(resetCredencial: ResetCredencial){
        let url = apiVucUrl + `api/v1.0/auth/credencialReset`;
        return this.http.post<ResetResponse>(url, resetCredencial, {observe: 'response'});
    }

    credencialResetCliente(resetCliente: ResetCliente){
        let url = apiVucUrl + `api/v1.0/auth/credencialReset/cliente`;
        return this.http.post<ResetResponse>(url, resetCliente, {observe: 'response'});
    }

    actualizarEstadoCredencial(credencialEstado: CredencialEstado){
        let url = apiVucUrl + `api/v1.0/auth/estado`;
        return this.http.put<CredencialEstado>(url, credencialEstado, {observe: 'response'});
    }
    asignarCredencialesRoles(asignar: AsignarRolesUsuario){
        let url = apiVucUrl + `api/v1.0/auth/asignar-roles`;
        return this.http.put<AsignarRolesUsuario>(url, asignar, {observe: 'response'});
    }
    actualizarEstadoRol(credencialRolEstado: CredencialRolEstado){
        let url = apiVucUrl + `api/v1.0/auth/estado-credencial-rol`;
        return this.http.put<CredencialRolEstado>(url, credencialRolEstado, {observe: 'response'});
    }

    consultarPersonaInfo(params: Param[]) {
        return this.http.post<PersonaInfo[]>(apiVucUrl + `api/v1.0/personas/info`, params, {observe: 'response'})
    }

    cambiarDocumento(payload: CambioDocumentoReq) {
        return this.http.post(apiVucUrl + `api/v1.0/personas/editar-documento`, payload, {observe: 'response'})
    }

    activarTodos() {
        return this.http.get(apiVucUrl + `api/v1.0/personas/activar-todos`, {observe: 'response'})
    }
}
